import React from 'react';
import './Banner.css'
import { BsArrowRight } from 'react-icons/bs';
import banner from '../../../img/banner/door-banner.png'

const Banner = () => {
  return (
    <div className='row banner ps-2 m-0'>
      <div className="col-md-6  banner-part-first">
        <div className='d-flex align-items-center h-100'>
          <div>
          <div className='text-white'>
            <h1 className='banner-title'>Welcome to the</h1>
            <h1 className='banner-title'>best Prime Door</h1>
          </div>
          <p className='secondary-clr py-3'>Our door warehouse is one of the best warehouse in our country . We provide the best product in the country. Thank you for choosing us.</p>
          <button className='explore-btn'><span className='pe-2'>Explore Now</span>
            <BsArrowRight></BsArrowRight>
          </button>
          </div>
        </div>
      </div>
      <div className="col-md-6 d-flex align-items-center h-100 banner-part-last">
        <img className='img-fluid' src={banner} alt="" />
      </div>
    </div>
  );
};

export default Banner;